import moment from 'moment';

/**
 * Gets user valid discount date
 *
 * @param   {number}  discountEnd  Discount end timestamp
 *
 * @returns  {string}              Formated discount end date
 */
export default (discountEnd) => discountEnd
    ? moment(discountEnd).format('MMM D, YYYY')
    : moment().add(1, 'years').format('MMM D, YYYY');
